// extracted by mini-css-extract-plugin
export default {"label":"EditUserDetail_label__sA+Qh","backButton":"EditUserDetail_backButton__j8Jpi"};